'use client';

import { Loader2 } from 'lucide-react';

/**
 * This file ensures the top-level layout (including navbar)
 * is hydrated and interactive while the (cms) route data is still streaming.
 * The user sees this fallback for the home content, but can click the nav immediately.
 */
export default function Loading() {
  return <div className="flex items-center justify-center w-full min-h-screen" data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
      <Loader2 className="h-8 w-8 animate-spin text-gray-400" data-sentry-element="Loader2" data-sentry-source-file="loading.tsx" />
    </div>;
}